/** Strip only a complete known legacy language segment, preserving calculator paths. */
export function canonicalEnglishPath(pathname: string): string {
  return pathname.replace(/^\/(?:en|pt-BR|pt-br|pt|es)(?=\/|$)/, '') || '/';
}
